import { useFormik } from "formik";
import InputField from "../../ui/form/InputField";
import { DeathApplicationValidation } from "../../../validation/formValidation";
import usePost from "../../../hooks/api/usePost";
import apiRequest from "../../../utils/apiRequest";
import FileInputField from "../../ui/form/FileInputField";
import Button from "../../ui/Button";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { formatDateForInput } from "../../../utils/helper";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import authManager from "../../../utils/authManager";
import handleApiError from "./handleApiError";
import FullScreenLoader from "../../ui/FullScreenLoader";
import PaymentOptions from "./PaymentOptions";
import { DASHBOARD_ROUTE, HOME_ROUTE } from "../../../routes/web/rootRoutes";

const DeathApplicationForm = ({ data = {} }) => {
  const [activeTab, setActiveTab] = useState(1);
  const [errors, setErrors] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [submissionResponse, setSubmissionResponse] = useState(null);
  const [submittedFormData, setSubmittedFormData] = useState(null);
         const navigate = useNavigate(); 


  const userString = localStorage.getItem('user');
  let union_code;
  if (userString) {
    const user = JSON.parse(userString);
    union_code = user.union_code;
  }

  const location = useLocation();
  const path = location.pathname.split('/')[1];

  const {
    post,
    isLoading: postLoading,
    error,
    serverErrors,
  } = usePost(apiRequest.createForm);

  const formik = useFormik({
    validationSchema: DeathApplicationValidation,
    initialValues: {
      // Member Details
      member_no: data?.member_no || union_code || "",
      date: data?.date || formatDateForInput(new Date()),
      member_name: data?.member_name || "",
      designation: data?.designation || "",
      address: data?.address || "",
      mobile: data?.mobile || "",
      email: data?.email || "",
      website: data?.website || "",

      // Death Details
      date_of_death: data?.date_of_death || "",
      reason_of_death: data?.reason_of_death || "",
      place_of_death: data?.place_of_death || "",
      addhar_no: data?.addhar || "",

      // File Uploads
      photo: null,
      nominee_photo: null,
      nominee_signature: null,
      member_signature: null,
      bank_passbook_cancelled_cheque: null,
      death_certificate: null,
      subscription: null,
      association_id_card: null,
      addhar_card: null,
    },

    onSubmit: async (values, { resetForm, setSubmitting }) => {
      setIsSubmitting(true);
      
      try {
        const formData = new FormData();

        // Text fields
        formData.append("member_no", values.member_no);
        formData.append("date", values.date);
        formData.append("member_name", values.member_name);
        formData.append("designation", values.designation);
        formData.append("address", values.address);
        formData.append("mobile", values.mobile);
        formData.append("email", values.email);
        formData.append("date_of_death", values.date_of_death);
        formData.append("reason_of_death", values.reason_of_death);
        formData.append("addhar_no", values.addhar_no);
        formData.append("place_of_death", values.place_of_death);

        // File fields with correct backend names
        if (values.photo) formData.append("member_photo", values.photo);
        if (values.nominee_photo) formData.append("member_nominee_photo", values.nominee_photo);
        if (values.nominee_signature) formData.append("member_nominee_signature", values.nominee_signature);
        if (values.member_signature) formData.append("member_member_signature", values.member_signature);
        if (values.bank_passbook_cancelled_cheque) formData.append("member_bank_passbook_cancelled_cheque", values.bank_passbook_cancelled_cheque);
        if (values.death_certificate) formData.append("member_death_certificate", values.death_certificate);
        if (values.subscription) formData.append("member_subscription", values.subscription);
        if (values.addhar_card) formData.append("member_addhar_card", values.addhar_card);
        if (values.association_id_card) formData.append("member_association_id_card", values.association_id_card);

        // Debug log
        console.log("Submitting Death Application:");
        for (let [key, val] of formData.entries()) {
          console.log(`${key}:`, val instanceof File ? `File: ${val.name}` : val);
        }

        const token = localStorage.getItem("useAccessToken");
        if (!token) {
          toast.error("Authentication token not found. Please login again.");
          setIsSubmitting(false);
          return;
        }

        const apiUrl = process.env.REACT_APP_API_URL;
        if (!apiUrl) {
          toast.error("API URL not configured");
          setIsSubmitting(false);
          return;
        }

        // Submit to API
        const response = await axios.post(
          `${apiUrl}deathform`,
          formData,
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${token}`,
            },
            maxBodyLength: Infinity,
            timeout: 30000,
          }
        );

        console.log("✅ Death application submitted:", response.data);
        
        setSubmissionResponse(response.data);
        setSubmittedFormData(values);
        
        toast.success("Death application submitted successfully!");
        resetForm();

        setTimeout(() => {
    navigate(DASHBOARD_ROUTE);
          
          setIsSubmitting(false);
          setShowPayment(true);

        }, 1500);

      } catch (error) {
        console.error("Submission error:", error);
        
        if (error.response) {
          console.error("Server Error:", error.response.data);
          toast.error(`Server error: ${error.response.status} - ${error.response.data?.message || 'Unknown error'}`);
        } else if (error.request) {
          console.error("No response from server");
          toast.error("No response from server. Please check your internet connection.");
        } else {
          console.error("Request error:", error.message);
          toast.error(`Error: ${error.message}`);
        }
        
        handleApiError(error, setErrors, "Failed to submit Death application");
        setIsSubmitting(false);
      } finally {
        setSubmitting(false);
      }
    }
  });

  const setFieldValue = (field, value) => {
    formik.setFieldValue(field, value);
  };

  const handleClosePayment = () => {
    setShowPayment(false);
    window.location.href = HOME_ROUTE;
  };

  const fetchFormData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}deathform`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${authManager.getAccessToken()}`,
          },
          maxBodyLength: Infinity,
        }
      );
      // Handle response data if needed
    } catch (error) {
      console.error("Error fetching form data:", error);
    }
  };

  useEffect(() => {
    if (path === 'show-form') {
      fetchFormData();
    }
  }, []);

  if (showPayment) {
    return (
      <>
        {showPayment && (
          <PaymentOptions
            onClose={handleClosePayment}
          />
        )}
      </>
    );
  }

  return (
    <>
      {isSubmitting && (
        <FullScreenLoader message="Submitting death application..." />
      )}

      <div className="max-w-7xl mx-auto p-6 bg-gradient-to-br min-h-screen">
        <div className="bg-white rounded-2xl shadow overflow-hidden">
          <div className="bg-gradient-to-r from-violet-500 to-violet-900 text-white p-6">
            <h1 className="text-center text-3xl font-bold mb-2">
              DEATH APPLICATION FORM
            </h1>
          </div>

          <form onSubmit={formik.handleSubmit} className="p-8">
            {/* Section 1: Member Number & Date */}
            <div className="mb-8 p-6 bg-gray-50 rounded-lg border-l-4 border-violet-500">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="block font-semibold text-gray-700">
                    Member No. <span className="text-red-500">*</span>
                  </label>
                  <InputField
                    id="member_no"
                    placeholder="Enter Membership No"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.member_no}
                    error={formik.touched.member_no && formik.errors.member_no}
                    serverError={serverErrors?.member_no}
                  />
                </div>
                <div className="space-y-2">
                  <label className="block font-semibold text-gray-700">
                    Date <span className="text-red-500">*</span>
                  </label>
                  <InputField
                    id="date"
                    type="date"
                    readOnly
                    placeholder="Select Date"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.date}
                    error={formik.touched.date && formik.errors.date}
                    serverError={serverErrors?.date}
                  />
                </div>
              </div>
            </div>

            {/* Section 2: Address Section */}
            <div className="mb-8 p-6 bg-blue-50 rounded-lg border-l-4 border-blue-500">
              <h3 className="text-xl font-semibold text-gray-800 mb-1">To,</h3>
              <h3 className="text-lg font-medium text-gray-700 mb-1">The President / General Secretary</h3>
              <h3 className="text-lg font-medium text-gray-700">Association of Cine & Television Art Directors & Costume Designers</h3>
            </div>

            {/* Section 3: Personal Information */}
            <div className="mb-8 p-6 bg-green-50 rounded-lg border-l-4 border-green-500">
              <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                <span className="mr-2">👤</span> Personal Information
              </h2>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="block font-semibold text-gray-700">
                    Member's Name <span className="text-red-500">*</span>
                  </label>
                  <InputField
                    id="member_name"
                    placeholder="Enter Member Name"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.member_name}
                    error={formik.touched.member_name && formik.errors.member_name}
                    serverError={serverErrors?.member_name}
                  />
                </div>

                <div className="space-y-2">
                  <label className="block font-semibold text-gray-700">
                    Designation <span className="text-red-500">*</span>
                  </label>
                  <InputField
                    id="designation"
                    placeholder="Enter designation"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.designation}
                    error={formik.touched.designation && formik.errors.designation}
                    serverError={serverErrors?.designation}
                  />
                </div>

                <div className="space-y-2 lg:col-span-2">
                  <label className="block font-semibold text-gray-700">
                    Residential Address <span className="text-red-500">*</span>
                  </label>
                  <InputField
                    id="address"
                    placeholder="Enter complete address"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.address}
                    error={formik.touched.address && formik.errors.address}
                    serverError={serverErrors?.address}
                  />
                </div>

                <div className="space-y-2">
                  <label className="block font-semibold text-gray-700">
                    Contact No. <span className="text-red-500">*</span>
                  </label>
                  <InputField
                    id="mobile"
                    placeholder="Enter mobile number"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.mobile}
                    error={formik.touched.mobile && formik.errors.mobile}
                    serverError={serverErrors?.mobile}
                  />
                </div>

                <div className="space-y-2">
                  <label className="block font-semibold text-gray-700">
                    Email ID <span className="text-red-500">*</span>
                  </label>
                  <InputField
                    id="email"
                    type="email"
                    placeholder="Enter email address"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.email}
                    error={formik.touched.email && formik.errors.email}
                    serverError={serverErrors?.email}
                  />
                </div>
              </div>
            </div>

            {/* Section 4: Death Details */}
            <div className="mb-8 p-6 bg-yellow-50 rounded-lg border-l-4 border-yellow-500">
              <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                <span className="mr-2">⚰️</span> Death Details
              </h2>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                <div className="space-y-2">
                  <label className="block font-semibold text-gray-700">
                    Date of Death <span className="text-red-500">*</span>
                  </label>
                  <InputField
                    id="date_of_death"
                    type="date"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.date_of_death}
                    error={formik.touched.date_of_death && formik.errors.date_of_death}
                    serverError={serverErrors?.date_of_death}
                  />
                </div>

                <div className="space-y-2">
                  <label className="block font-semibold text-gray-700">
                    Place of Death <span className="text-red-500">*</span>
                  </label>
                  <InputField
                    id="place_of_death"
                    placeholder="Enter place of death"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.place_of_death}
                    error={formik.touched.place_of_death && formik.errors.place_of_death}
                    serverError={serverErrors?.place_of_death}
                  />
                </div>

                <div className="space-y-2 lg:col-span-2">
                  <label className="block font-semibold text-gray-700">
                    Reason of Death <span className="text-red-500">*</span>
                  </label>
                  <InputField
                    id="reason_of_death"
                    placeholder="Enter reason of death"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.reason_of_death}
                    error={formik.touched.reason_of_death && formik.errors.reason_of_death}
                    serverError={serverErrors?.reason_of_death}
                  />
                </div>

                <div className="space-y-2">
                  <label className="block font-semibold text-gray-700">
                    Aadhar No <span className="text-red-500">*</span>
                  </label>
                  <InputField
                    id="addhar_no"
                    placeholder="Enter Aadhar No"
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.addhar_no}
                    error={formik.touched.addhar_no && formik.errors.addhar_no}
                    serverError={serverErrors?.addhar_no}
                  />
                </div>
              </div>
            </div>

            {/* Section 5: Documents Upload */}
            <div className="mb-8 p-6 bg-orange-50 rounded-lg border-l-4 border-orange-500">
              <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                <span className="mr-2">📎</span> Documents Upload
                <span className="text-sm font-normal text-gray-600 ml-2">(Please upload all required documents)</span>
              </h2>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {/* Required Documents */}
                <div className="space-y-4 p-6 bg-red-50 rounded-lg border border-red-200">
                  <h3 className="text-lg font-semibold text-red-800 mb-4 flex items-center">
                    <span className="mr-2">📋</span> Required Documents
                  </h3>

                  <div className="space-y-4">
                    <div className="space-y-2">
                      <label className="block font-semibold text-gray-700">
                        Association ID Card Copy <span className="text-red-500">*</span>
                      </label>
                      <FileInputField
                        id="association_id_card"
                        onChange={(event) => {
                          setFieldValue("association_id_card", event.currentTarget.files[0]);
                        }}
                        onBlur={formik.handleBlur}
                        error={formik.touched.association_id_card && formik.errors.association_id_card}
                        serverError={serverErrors?.association_id_card}
                      />
                      <p className="text-xs text-gray-500">Upload scanned copy of ID card</p>
                    </div>

                    <div className="space-y-2">
                      <label className="block font-semibold text-gray-700">
                        Aadhar Card Copy <span className="text-red-500">*</span>
                      </label>
                      <FileInputField
                        id="addhar_card"
                        onChange={(event) => {
                          setFieldValue("addhar_card", event.currentTarget.files[0]);
                        }}
                        onBlur={formik.handleBlur}
                        error={formik.touched.addhar_card && formik.errors.addhar_card}
                        serverError={serverErrors?.addhar_card}
                      />
                      <p className="text-xs text-gray-500">Upload scanned copy of Aadhar card</p>
                    </div>

                    <div className="space-y-2">
                      <label className="block font-semibold text-gray-700">
                        Death Certificate <span className="text-red-500">*</span>
                      </label>
                      <FileInputField
                        id="death_certificate"
                        onChange={(event) => {
                          setFieldValue("death_certificate", event.currentTarget.files[0]);
                        }}
                        onBlur={formik.handleBlur}
                        error={formik.touched.death_certificate && formik.errors.death_certificate}
                        serverError={serverErrors?.death_certificate}
                      />
                      <p className="text-xs text-gray-500">Upload original death certificate</p>
                    </div>
                  </div>
                </div>

                {/* Financial Documents */}
                <div className="space-y-4 p-6 bg-green-50 rounded-lg border border-green-200">
                  <h3 className="text-lg font-semibold text-green-800 mb-4 flex items-center">
                    <span className="mr-2">💳</span> Financial Documents
                  </h3>

                  <div className="space-y-4">
                    <div className="space-y-2">
                      <label className="block font-semibold text-gray-700">
                        Bank Passbook/Cancelled Cheque <span className="text-red-500">*</span>
                      </label>
                      <FileInputField
                        id="bank_passbook_cancelled_cheque"
                        onChange={(event) => {
                          setFieldValue("bank_passbook_cancelled_cheque", event.currentTarget.files[0]);
                        }}
                        onBlur={formik.handleBlur}
                        error={formik.touched.bank_passbook_cancelled_cheque && formik.errors.bank_passbook_cancelled_cheque}
                        serverError={serverErrors?.bank_passbook_cancelled_cheque}
                      />
                      <p className="text-xs text-gray-500">Upload bank proof for claim settlement</p>
                    </div>

                    <div className="space-y-2">
                      <label className="block font-semibold text-gray-700">
                        Last Subscription Receipt <span className="text-red-500">*</span>
                      </label>
                      <FileInputField
                        id="subscription"
                        onChange={(event) => {
                          setFieldValue("subscription", event.currentTarget.files[0]);
                        }}
                        onBlur={formik.handleBlur}
                        error={formik.touched.subscription && formik.errors.subscription}
                        serverError={serverErrors?.subscription}
                      />
                      <p className="text-xs text-gray-500">Upload latest subscription receipt</p>
                    </div>
                  </div>
                </div>

                {/* Photos & Signatures - Full Width */}
                <div className="space-y-4 p-6 bg-blue-50 rounded-lg border border-blue-200 lg:col-span-2">
                  <h3 className="text-lg font-semibold text-blue-800 mb-4 flex items-center">
                    <span className="mr-2">📸</span> Photos & Signatures
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                    <div className="space-y-2">
                      <label className="block font-semibold text-gray-700">
                        Member Photo <span className="text-red-500">*</span>
                      </label>
                      <FileInputField
                        id="photo"
                        onChange={(event) => {
                          setFieldValue("photo", event.currentTarget.files[0]);
                        }}
                        onBlur={formik.handleBlur}
                        error={formik.touched.photo && formik.errors.photo}
                        serverError={serverErrors?.photo}
                      />
                      <p className="text-xs text-gray-500">Passport size photo</p>
                    </div>

                    <div className="space-y-2">
                      <label className="block font-semibold text-gray-700">
                        Nominee Photo <span className="text-red-500">*</span>
                      </label>
                      <FileInputField
                        id="nominee_photo"
                        onChange={(event) => {
                          setFieldValue("nominee_photo", event.currentTarget.files[0]);
                        }}
                        onBlur={formik.handleBlur}
                        error={formik.touched.nominee_photo && formik.errors.nominee_photo}
                        serverError={serverErrors?.nominee_photo}
                      />
                      <p className="text-xs text-gray-500">Nominee's passport size photo</p>
                    </div>

                    <div className="space-y-2">
                      <label className="block font-semibold text-gray-700">
                        Member Signature <span className="text-red-500">*</span>
                      </label>
                      <FileInputField
                        id="member_signature"
                        onChange={(event) => {
                          setFieldValue("member_signature", event.currentTarget.files[0]);
                        }}
                        onBlur={formik.handleBlur}
                        error={formik.touched.member_signature && formik.errors.member_signature}
                        serverError={serverErrors?.member_signature}
                      />
                      <p className="text-xs text-gray-500">Member's scanned signature</p>
                    </div>

                    <div className="space-y-2">
                      <label className="block font-semibold text-gray-700">
                        Nominee Signature <span className="text-red-500">*</span>
                      </label>
                      <FileInputField
                        id="nominee_signature"
                        onChange={(event) => {
                          setFieldValue("nominee_signature", event.currentTarget.files[0]);
                        }}
                        onBlur={formik.handleBlur}
                        error={formik.touched.nominee_signature && formik.errors.nominee_signature}
                        serverError={serverErrors?.nominee_signature}
                      />
                      <p className="text-xs text-gray-500">Nominee's scanned signature</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Section 6: Declaration */}
            <div className="mb-8 p-6 bg-purple-50 rounded-lg border-l-4 border-purple-500">
              <h2 className="text-xl font-bold text-gray-800 mb-4 flex items-center">
                <span className="mr-2">📜</span> Declaration
              </h2>

              <div className="space-y-4">
                <p className="text-sm text-gray-700">
                  I hereby declare that the information provided above is true and correct to the best of my knowledge. 
                  I understand that any false information may lead to rejection of this application.
                </p>

                <div className="flex items-center">
                  <input
                    type="checkbox"
                    id="agree"
                    name="agree"
                    onChange={(e) => formik.setFieldValue('agree', e.target.checked)}
                    className="w-4 h-4 text-violet-600 border-gray-300 rounded focus:ring-violet-500"
                  />
                  <label htmlFor="agree" className="ml-2 text-sm text-gray-700">
                    I confirm that the deceased was a member of ACTADCD and all dues are cleared <span className="text-red-500">*</span>
                  </label>
                </div>
                {formik.touched.agree && formik.errors.agree && (
                  <p className="mt-1 text-xs text-red-500">{formik.errors.agree}</p>
                )}
              </div>
            </div>

            {/* Submit Button */}
            <div className="mt-8 flex justify-end items-center bg-gray-50 p-6 rounded-lg">
              <Button
                variant="primary"
                type="submit"
                isLoading={postLoading || isSubmitting}
                disabled={postLoading || isSubmitting}
                className="px-8 py-3 text-lg"
              >
                {isSubmitting ? 'Submitting...' : '📤 Submit Application'}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default DeathApplicationForm;